import React, { useEffect } from 'react';
import './_popup.scss';

export function showPopup (parentClass) {
  const classname = `${
    parentClass ? `${parentClass} #popupContainer` : '#popupContainer'
  }`;
  const popupElement = document.querySelector(classname);
  popupElement.classList.add('show');
  const popupBody = popupElement.querySelector('#popupBlock');
  popupBody.scrollTop = 0;
  // document.body.style.overflow = 'hidden';
}

function Popup ({ videoUrl, htmlTemplate, parentClass }) {
  function createVideoUrl (url) {
    const vimeo_Reg = /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
    const watchY = url.match(/(\?|&)v=([^&#]+)/);
    const embedY = url.match(/(\.be\/)+([^/]+)/);
    const beY = url.match(/(embed\/)+([^/]+)/);
    const vimeoURL = url.match(vimeo_Reg);
    const videoURL = url.match(/https:\/\/(:?www.)?(\w*)/)[2];
    if (videoURL.includes('youtu')) {
      if (watchY) {
        return 'https://www.youtube.com/embed/' + watchY.pop();
      } else if (embedY) {
        return 'https://www.youtube.com/embed/' + embedY.pop();
      } else if (beY) {
        return 'https://www.youtube.com/embed/' + beY.pop();
      }
    } else if (videoURL.includes('vimeo') || videoURL.includes('player')) {
      if (vimeoURL) {
        return 'https://player.vimeo.com/video/' + vimeoURL[3];
      }
    }
  }

  function closePopup () {
    const iFrame = document.querySelector('#responsive-iframe');
    iFrame && iFrame.setAttribute('src', iFrame.getAttribute('src'));
    document
      .querySelector(`${parentClass || ''} #popupContainer`)
      .classList.remove('show');
    // document.body.style.overflow = 'auto';
  }

  function hidePopupWithEsc (e) {
    e.keyCode === 27 && closePopup();
  }

  useEffect(() => {
    window.addEventListener('keyup', hidePopupWithEsc);
    return () => window.removeEventListener('keyup', hidePopupWithEsc);
  }, []);

  return (
    <div className='popupContainer' id='popupContainer'>
      <div className='closeDiv' onClick={closePopup}>
        <div className='closeIcon' />
      </div>
      <div className='popupBlock' id='popupBlock'>
        {videoUrl && (
          <iframe
            title='Video'
            id='responsive-iframe'
            className='responsive-iframe'
            src={createVideoUrl(videoUrl)}
          />
        )}
        {htmlTemplate && htmlTemplate}
      </div>
    </div>
  );
}

export default Popup;
